export const focusAreaOptions = [
  "Focus & Concentration",
  "Confidence & Self-Belief",
  "Resilience & Performing Under Pressure",
  "Motivation & Drive",
  "Self-Regulation & Emotional Control",
  "Team Cohesion & Communication",
  "Leadership Development",
  "Injury Recovery"
];

export const challengeOptions = [
  "Performance Anxiety",
  "Lack of Focus",
  "Low Confidence",
  "Stress Management",
  "Motivation Issues",
  "Pressure Handling",
  "Recovery after Mistakes",
  "Team Communication"
];

export const trainingGoalOptions = [
  "Improve Focus",
  "Build Confidence",
  "Reduce Anxiety",
  "Better Stress Management",
  "Enhanced Visualization",
  "Stronger Mental Resilience",
  "Better Pre-Game Routine",
  "Improved Team Communication"
];

export const exerciseTypeOptions = [
  "Breathing Exercises",
  "Visualization",
  "Meditation",
  "Mindfulness",
  "Progressive Muscle Relaxation",
  "Goal Setting Activities",
  "Confidence Building",
  "Focus Training"
];

export const skillTypeOptions = [
  "Pre-Game Mental Preparation",
  "Visualization & Mental Imagery",
  "Confidence & Self-Belief",
  "Performance Anxiety Management",
  "Focus & Concentration Training",
  "Emotional Regulation",
  "Motivation & Drive",
  "Team Communication & Leadership",
  "Mistake Recovery & Resilience",
  "Pressure Performance",
  "Goal Setting & Achievement",
  "Self-Talk & Inner Dialogue",
  "Mindfulness & Present Moment Awareness",
  "Competitive Mindset Development",
  "Stress Management",
  "Mental Toughness Building",
  "Injury Recovery"
];

export const targetAudienceOptions = [
  "Individual Athletes",
  "Team Athletes",
  "Youth Athletes (Under 16)",
  "College Athletes",
  "Professional Athletes",
  "Recreational Athletes",
  "Coaches",
  "Parents of Athletes",
  "Mixed Groups"
];

export const difficultyLevels = [
  { value: "beginner", label: "Beginner - New to mental training" },
  { value: "intermediate", label: "Intermediate - Some experience" },
  { value: "advanced", label: "Advanced - Experienced practitioners" }
];
